import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=15b1ae3c&"
import script from "./FullCalendar.vue?vue&type=script&lang=js&"
export * from "./FullCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports